import React,{useState,useRef} from "react";
import "./style.css";
import {useNavigate} from "react-router-dom";
import {Modal, Button} from "react-bootstrap"
import {UrlBaseServer} from "../../../Services/storageServer";
import {useAuth} from "../../../Services/auth";
import {useQuery} from "react-query";
import api from "../../../Services/api"
import visaCard from "./../../../Assets/visaLogo.png"

import data from "bootstrap/js/src/dom/data";
const Index = () => {
    const navigate = useNavigate();

    const {user} = useAuth()
    const { isLoading,
        isError,
        error,
        data:dataBlogs,
        isFetching,
        isPreviousData, } = useQuery(['repoBlogs'], ()=> api.getBlogs(),{ keepPreviousData : true }
    )
    function getDate(d){
        const maDate = new Date(d)

        return maDate.toLocaleDateString("fr")
    }
    return (
        <div className="container mt-5 FeedBackBox">
            <div className="row">
        <div>
            {dataBlogs?.data?.map((v, i) => {
                return(

                    <div style={{width:"100%"}} className="whiteContainer" key={"blogs_"+i}>
                        <div>
                            <h3>{v.title}</h3>
                            <div style={{color:"gray"}}>Le {getDate(v?.createdAt)}</div>
                            <div dangerouslySetInnerHTML={{ __html: v?.description }}></div>
                            <button className="btn2" style={{cursor:"pointer", marginTop:10}} onClick={()=>{
                                navigate("/blog/"+v.slugUrl)
                                //navigate("/edit-bottle")
                            }}>Lire la suite</button>
                        </div>
                    </div>
                )
            })}
            {dataBlogs?.data.length ==0 && (
                <div style={{width:"100%", fontSize:18, padding:50}} className="whiteContainer" >
                    Notre blog est en fermentation, mais il sera bientôt mis en bouteille !
                </div>
            )}
        </div></div></div>
  );
};
export default Index;
